import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from './contexts/ThemeContext';
import { AuthProvider } from './contexts/AuthContext';
import Layout from './components/Layout';
import ProtectedRoute from './components/ProtectedRoute';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import Expertise from './pages/Expertise';
import CaseStudies from './pages/CaseStudies';
import Contact from './pages/Contact';
import Login from './pages/Login';
import Callback from './pages/Callback';
import Presentations from './pages/Presentations';
import PresentationViewer from './pages/PresentationViewer';
import Demos from './pages/Demos';
import ArtSearchDemo from './pages/ArtSearchDemo';
import StyleA from './pages/styles/StyleA';
import StyleB from './pages/styles/StyleB';
import StyleC from './pages/styles/StyleC';
import StyleD from './pages/styles/StyleD';
import StyleE from './pages/styles/StyleE';
import StyleF from './pages/styles/StyleF';
import StyleG from './pages/styles/StyleG';

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <Router>
          <Routes>
            {/* Auth routes - no layout */}
            <Route path="/login" element={<Login />} />
            <Route path="/callback" element={<Callback />} />

            {/* Protected presentation routes - no layout */}
            <Route
              path="/presentations"
              element={
                <ProtectedRoute>
                  <Presentations />
                </ProtectedRoute>
              }
            />
            <Route
              path="/presentations/:slug"
              element={
                <ProtectedRoute>
                  <PresentationViewer />
                </ProtectedRoute>
              }
            />

            {/* Protected demo routes - no layout */}
            <Route
              path="/demos"
              element={
                <ProtectedRoute>
                  <Demos />
                </ProtectedRoute>
              }
            />
            <Route
              path="/demos/art-search"
              element={
                <ProtectedRoute>
                  <ArtSearchDemo />
                </ProtectedRoute>
              }
            />

            {/* Public routes with layout */}
            <Route path="/" element={<Layout><Home /></Layout>} />
            <Route path="/about" element={<Layout><About /></Layout>} />
            <Route path="/services" element={<Layout><Services /></Layout>} />
            <Route path="/expertise" element={<Layout><Expertise /></Layout>} />
            <Route path="/case-studies" element={<Layout><CaseStudies /></Layout>} />
            <Route path="/contact" element={<Layout><Contact /></Layout>} />
            <Route path="/style-a" element={<Layout><StyleA /></Layout>} />
            <Route path="/style-b" element={<Layout><StyleB /></Layout>} />
            <Route path="/style-c" element={<Layout><StyleC /></Layout>} />
            <Route path="/style-d" element={<Layout><StyleD /></Layout>} />
            <Route path="/style-e" element={<Layout><StyleE /></Layout>} />
            <Route path="/style-f" element={<Layout><StyleF /></Layout>} />
            <Route path="/style-g" element={<Layout><StyleG /></Layout>} />
          </Routes>
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;